import { Component, Output, EventEmitter } from '@angular/core';
import { Modal } from 'bootstrap';

import { Data2Service } from 'src/app/common/data2.service';
import { LoaderService } from 'src/app/common/loader/loader.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';

@Component({
	selector: 'app-transports-map-templates',
	templateUrl: './transports-map-templates.component.html',
	styleUrls: ['./transports-map-templates.component.css'],
})
export class TransportsMapTemplatesComponent {
	@Output() selected = new EventEmitter();
	private transport: number = null;
	private side: string = null;
	private seasons: Array<any> = [];
	data: Array<any> = [];

	constructor(
		private readonly api: Data2Service,
		private readonly loader: LoaderService,
		private readonly infobox: InfoboxService,
	) {}

	open(transport: number, side: string, seasons: Array<any>): void {
		this.transport = transport;
		this.side = side;
		this.seasons = seasons;
		this.loader.show();
		this.api.get('/bag/bagTransportTemplates/', (result, error) => {
			new Modal(document.getElementById('loadTemplate')).show();
			this.data = result.data;
			this.loader.hide();
		});
	}

	select(item): void {
		const data = {
			cmd: 'loadTemplate',
			data: {
				template: item.id,
				transport: this.transport,
				seasons: this.seasons,
			},
		};
		this.loader.show();
		this.api.command('/bag/bagTransportsLogic', data, (result, error) => {
			this.loader.hide();
			if (error) {
				return;
			}
			this.selected.emit(true);
		});
	}
}
